export default "__VITE_ASSET__DcCYnQPN__";